import React from "react";
import MultiFaceSwapTemplate from "../../components/MultiFaceSwapTemplate";
import { MultiFaceSwapFeatures } from "../../components/Features";
import { MultiFaceSwapHeroSection } from "../../components/HeroSection";
import { MultiFaceSwapFAQ } from "../../components/faqs";
import { MultiFaceSwapGuide } from "../../components/sections/FaceSwapGuide";
import { WhoCanUseMultiFaceSwap } from "../../components/sections/WhoCanUseSnapToon";
import { MultiFaceSwapBenefits } from "../../components/sections/SnapToonBenefits";
import { Groups } from "@mui/icons-material";

const MultipleFaceSwap: React.FC = () => {
  return (
    <MultiFaceSwapTemplate
      initialSwappedImage="https://snaptoon-development.s3.eu-north-1.amazonaws.com/snaptoon_web/multi-face-initial.jpg"
      toastPrefix="Multi-Face"
      badgeIcon={<Groups sx={{ fontSize: 18, color: "#c084fc" }} />}
      badgeText="Multi-Face AI Technology"
      heroHeading="Swap Multiple Faces at Once – Family & Group Swaps!"
      heroSubheading="Effortless Multi-Face Swapping for Families, Couples & Friends"
      heroText="Why swap just one face when you can swap them all? With SwapToon’s multiple face swap feature, you can swap faces with family, friends, or even your partner in a single image! Whether it’s a group selfie, couple’s photo, or a full family portrait, our AI-powered multi-face swap technology ensures smooth, high-quality results in seconds."
      HeroSectionComponent={MultiFaceSwapHeroSection}
      FeaturesComponent={MultiFaceSwapFeatures}
      GuideComponent={MultiFaceSwapGuide}
      WhoCanUseComponent={WhoCanUseMultiFaceSwap}
      BenefitsComponent={MultiFaceSwapBenefits}
      FAQComponent={MultiFaceSwapFAQ}
    />
  );
};

export default MultipleFaceSwap;
